import * as React from "react";
import { cn } from "@/lib/utils";

type RadioGroupProps = React.HTMLAttributes<HTMLDivElement>;

function RadioGroup({ className, ...props }: RadioGroupProps) {
  return <div className={cn("grid gap-3", className)} {...props} />;
}

type RadioGroupItemProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, "type">;

const RadioGroupItem = React.forwardRef<HTMLInputElement, RadioGroupItemProps>(({ className, ...props }, ref) => (
  <input
    ref={ref}
    type="radio"
    className={cn("h-5 w-5 border-input text-accent focus:ring-ring", className)}
    {...props}
  />
));
RadioGroupItem.displayName = "RadioGroupItem";

export { RadioGroup, RadioGroupItem };
